// extracted by mini-css-extract-plugin
export default {"alert":"PhishingAlert-alert__fgNjV","spacing":"PhishingAlert-spacing__uPqNs"};